import { render } from "./TaskAssessmentModal.vue?vue&type=template&id=7906d464&scoped=true"
import script from "./TaskAssessmentModal.vue?vue&type=script&lang=js"
export * from "./TaskAssessmentModal.vue?vue&type=script&lang=js"

import "./TaskAssessmentModal.vue?vue&type=style&index=0&id=7906d464&scoped=true&lang=css"
/* custom blocks */
import block0 from "./TaskAssessmentModal.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7906d464"]])

export default __exports__